<template>
  <div>
    <!-- <div class="top-group">
      <i class="iconfont icon-daoru" @click="uploadVisible = !uploadVisible"></i>
      <i class="iconfont icon-daochu" @click="exportFile"></i>
    </div> -->
    <h1>{{ $t("advancedProgramming") }}</h1>
    <div class="program-main">
      <div class="left-section">
        <div class="top-section">
          <el-input v-model="actionNum" :placeholder="$t('actionNumber')" />
          <el-button
            class="blue-btn"
            style="width: 40px"
            icon="el-icon-search"
            @click="searchActionNum"
          ></el-button>
        </div>
        <div class="action-list">
          <template v-for="(item, index) in actionNumList">
            <div
              class="item"
              v-if="!filterKey || formatNo(index + 1).indexOf(filterKey) > -1"
              :key="item.id"
            >
              <div class="action-item-content">
                <span
                  class="pointer"
                  :class="[
                    item.id === activeId ? 'active' : '',
                    !item.bothExist ? 'warning' : null
                  ]"
                  @click="handleAction(item.id, index + 1)"
                  >{{ formatNo(index + 1) }}</span
                >
                <el-input
                  v-model="item.descr"
                  :placeholder="$t('description')"
                  size="mini"
                  class="descr-input"
                  @blur="saveActionNumDescr(item)"
                  @click.native.stop
                />
              </div>
              <i
                class="iconfont icon-shanchu"
                @click="delActionNum(item.id, index + 1)"
              ></i>
            </div>
          </template>
        </div>
        <div class="add-btn">
          <i class="iconfont icon--" @click="addActionNum"></i>
        </div>
      </div>
      <div class="right-section">
        <div class="top-section">
          <div class="title" ref="midBox">
            {{ $t("scenario")
            }}<template v-if="activeNum !== 0"
              >: {{ formatNo(activeNum) }}</template
            >
            <el-button
              style="float: right"
              class="blue-btn"
              @click="saveAllAps"
              >{{ $t("save") }}</el-button
            >
          </div>
          <Table
            show-summary
            :dataSource="[...scenarioSource, ...scenarioNew]"
            :columns="scenarioColumns"
            v-if="height"
            :height="height"
          >
            <template #line>
              <el-table-column :label="$t('line')" width="110">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
            </template>
            <template #operation>
              <el-table-column :label="$t('operation')" width="120">
                <template slot-scope="scope">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="$t('delete')"
                    :hide-after="2000"
                    placement="top"
                  >
                    <i
                      class="iconfont icon-shanchu pointer"
                      @click="delScenarioRow(scope.row, scope.$index)"
                    ></i>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="$t('save')"
                    :hide-after="2000"
                    placement="top"
                  >
                    <i
                      v-if="scope.row.isEdit"
                      :class="{ active: scope.row.id }"
                      class="iconfont icon-baocun pointer"
                      @click="saveScenarioRow(scope.row, scope.$index)"
                    ></i>
                  </el-tooltip>
                </template>
              </el-table-column>
            </template>
          </Table>
          <div class="add-btn">
            <i
              class="iconfont icon--"
              :class="{ 'diabled-icon': activeId === '' }"
              @click="addNewAps"
            ></i>
          </div>
        </div>
        <div class="bottom">
          <div class="title">
            {{ $t("activation") }}
            <el-button
              style="float: right"
              class="blue-btn"
              @click="saveAllApa"
              >{{ $t("save") }}</el-button
            >
          </div>
          <Table
            v-if="height"
            :height="height"
            :dataSource="[...activationSource, ...activationNew]"
            :columns="activationColumns"
          >
            <template #line>
              <el-table-column :label="$t('line')" width="110">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
            </template>
            <template #operation>
              <el-table-column :label="$t('operation')" width="120">
                <template slot-scope="scope">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="$t('delete')"
                    :hide-after="2000"
                    placement="top"
                  >
                    <i
                      class="iconfont icon-shanchu pointer"
                      @click="delActivationRow(scope.row, scope.$index)"
                    ></i>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="$t('save')"
                    :hide-after="2000"
                    placement="top"
                  >
                    <i
                      v-if="scope.row.isEdit"
                      :class="{ active: scope.row.id }"
                      class="iconfont icon-baocun pointer"
                      @click="saveActivationRow(scope.row, scope.$index)"
                    ></i>
                  </el-tooltip>
                </template>
              </el-table-column>
            </template>
          </Table>
          <div class="add-btn">
            <i
              class="iconfont icon--"
              :class="{ 'diabled-icon': activeId === '' }"
              @click="addNewApa"
            ></i>
          </div>
        </div>
      </div>
    </div>
    <uploadModal
      :type="3"
      v-if="uploadVisible"
      :text="$t('importAdvance')"
      @close="uploadVisible = !uploadVisible"
      @upload="upload"
    />
  </div>
</template>

<script>
import {
  getActionNumList,
  addActionNum,
  delActionNum,
  updateActionNum,
  getApsList,
  addAps,
  delAps,
  updateAps,
  getApaList,
  addApa,
  delApa,
  updateApa,
  saveAllAps,
  saveAllApa
} from "../../api/program";
import config from "../../common/config";
import { importAdvance, exportAdvance } from "../../api/importAndExport";
import uploadModal from "../../components/uploadModal.vue";
import Cookies from "js-cookie";

export default {
  name: "advancedProgramming",
  components: { uploadModal },
  data() {
    return {
      actionNum: "",
      filterKey: "",
      activeId: "",
      activeNum: 0,
      actionNumList: [],
      scenarioSource: [],
      scenarioSourceCopy: [],
      scenarioNew: [],
      scenarioColumns: [
        {
          prop: "line",
          label: this.$t("line"),
          minWidth: 100,
          slotName: "line"
        },
        {
          prop: "zone",
          label: this.$t("zone"),
          minWidth: 100
        },
        {
          prop: "alarmType",
          label: this.$t("alarmType"),
          minWidth: 120
        },
        {
          prop: "quantityOfAlarms",
          label: this.$t("quantityOfAlarms"),
          minWidth: 150
        },
        {
          prop: "combination",
          label: this.$t("combination"),
          minWidth: 120
        },
        {
          slotName: "operation"
        }
      ],
      activationSource: [],
      activationSourceCopy: [],
      activationNew: [],
      activationColumns: [
        {
          prop: "line",
          label: this.$t("line"),
          slotName: "line",
          minWidth: 80
        },
        {
          prop: "groupToActivate",
          label: this.$t("groupToActivate"),
          minWidth: 200
        },
        {
          prop: "delay",
          label: this.$t("delay"),
          minWidth: 100
        },
        {
          prop: "hold",
          label: this.$t("hold"),
          minWidth: 200
        },
        {
          prop: "twoStages",
          label: this.$t("twoStages"),
          tooltip: this.$t("twoStagesVersionTip"),
          minWidth: 120
        },
        {
          slotName: "operation"
        }
      ],
      quantityOfAlarmsArr: [
        {
          name: 1,
          value: 1
        },
        {
          name: 2,
          value: 2
        },
        {
          name: 3,
          value: 3
        },
        {
          name: 4,
          value: 4
        }
      ],
      combinationArr: [
        {
          name: "AND",
          value: 1
        },
        {
          name: "OR",
          value: 0
        }
      ],
      uploadVisible: false,
      panelNo: this.$route.query.panelNo,
      projectId: this.$route.query.projectId,
      canAddaps: true,
      canAddapa: true,
      height: 0
    };
  },
  watch: {
    activeNum(val) {
      // 清除新增的
      this.activationNew = [];
      this.scenarioNew = [];
    }
  },
  mounted() {
    this.getActionNumList();
    const height =
      window.innerHeight - this.$refs.midBox.getBoundingClientRect().top - 70;
    this.height = height < 400 ? 400 : height / 2 - 90;
    if (this.height <= 400) {
      this.height = 400;
    }
  },
  beforeRouteLeave(to, from, next) {
    // 在token失效时,会跳转到/，此时不必拦截
    if (to.path !== "/") {
      const unSaveValue = this.checkData();
      if (unSaveValue) {
        next(false);
        this.showMsg(0, 0, unSaveValue, () => next(true));
      } else if (this.scenarioNew.length > 0 || this.activationNew.length > 0) {
        this.showMsg(0, 0, unSaveValue, () => next(true));
        next(false);
      } else {
        next();
      }
    } else {
      next();
    }
  },
  methods: {
    getActionNumList() {
      const params = {
        panelNo: this.panelNo,
        projectId: this.projectId
      };
      getActionNumList(params).then(res => {
        this.actionNumList = res.data;
      });
    },
    saveActionNumDescr(item) {
      const params = {
        id: item.id,
        projectId: this.projectId,
        panelNo: this.panelNo,
        num: item.num,
        descr: item.descr || ""
      };
      updateActionNum(params).then(res => {
        this.$message.success(this.$t("saveSuccess"));
      });
    },
    addActionNum() {
      // let num = 'S001'
      // if (this.actionNumList.length > 0) {
      //   num = +this.actionNumList[this.actionNumList.length - 1].num.substr(1) + 1
      //   num = 'S' + '000'.substr(0, 3 - ('' + num).length) + num
      // }
      if (this.actionNumList.length >= 400) {
        this.$message.error(this.$t("actionNumLimit"));
        return;
      }
      const params = {
        projectId: this.projectId,
        panelNo: this.panelNo
      };
      addActionNum(params).then(res => {
        this.$message.success(this.$t("addSuccess"));
        this.actionNum = "";
        this.filterKey = "";
        this.getActionNumList();
      });
    },
    delActionNum(id, index) {
      this.$msgbox({
        title: this.$t("prompt"),
        message: this.$t("sureDelete"),
        showCancelButton: true,
        confirmButtonText: this.$t("sure"),
        cancelButtonText: this.$t("cancel"),
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            const params = {
              projectId: this.projectId,
              id: id
            };
            delActionNum(params).then(res => {
              this.$message.success(this.$t("deleteSuccess"));
              this.getActionNumList();
              if (index < this.activeNum) {
                this.activeNum--;
              } else if (index === this.activeNum) {
                this.activeNum = 0;
                this.scenarioSource = [];
                this.scenarioSourceCopy = [];
                this.activationSource = [];
                this.activationSourceCopy = [];
              }
              done();
            });
          } else {
            done();
          }
        }
      }).then(action => {});
    },
    handleAction(id, index) {
      if (this.activeNum !== index) {
        // 判断只有当新增的数据为空时，才可以切换，否则提示保存
        const unSaveValue = this.checkData();
        if (unSaveValue) {
          this.showMsg(id, index, unSaveValue);
        } else {
          if (
            this.scenarioNew.length === 0 &&
            this.activationNew.length === 0
          ) {
            this.activeId = id;
            this.activeNum = index;
            this.getApsList();
            this.getApaList();
          } else {
            this.showMsg(id, index);
          }
        }
      }
    },
    getApsList() {
      const params = {
        actionNumId: this.activeId
      };
      getApsList(params).then(res => {
        this.canAddaps = true;
        this.scenarioSource = res.data.map((n, i) => {
          return {
            isEdit: true,
            id: n.id,
            // line: {
            //   value: i + 1
            // },
            zone: {
              value: n.zone,
              type: "input",
              width: 120,
              change: data => {
                const value = +data.value;
                if (value < 0 || value > 400 || isNaN(value)) {
                  this.$message.error(this.$t("outOfRange"));
                  data.value = 1;
                }
              }
            },
            alarmType: {
              value: n.alarmType,
              type: "select",
              width: 120,
              options: this.handleGlobalArr(config.alarmTypeArr)
            },
            quantityOfAlarms: {
              value: n.alarmCounts,
              type: "select",
              width: 120,
              options: this.quantityOfAlarmsArr
            },
            combination: {
              value: n.combination,
              type: "select",
              width: 120,
              options: this.combinationArr
            }
          };
        });
        this.scenarioSourceCopy = JSON.parse(
          JSON.stringify(this.scenarioSource)
        );
      });
    },
    addNewAps() {
      if (!this.activeId) {
        return;
      }
      if (!this.canAddaps) {
        this.$message.error(this.$t("unSavedWarning"));
        return;
      }
      if (this.scenarioSource.length + this.scenarioNew.length >= 32) {
        this.$message.error(this.$t("scenarioLimit"));
        return;
      }
      let value = 1;
      let zone = 1;
      const scenarioAll = this.scenarioSource.concat(this.scenarioNew);
      if (scenarioAll.length > 0) {
        scenarioAll.map(n => {
          if (n.zone.value > zone) {
            zone = n.zone.value;
          }
        });
        zone += 1;
      }
      this.scenarioNew.push({
        isEdit: true,
        line: {
          value: value
        },
        zone: {
          value: zone,
          type: "input",
          width: 120,
          change: data => {
            const value = +data.value;
            if (value < 0 || value > 400 || isNaN(value)) {
              this.$message.error(this.$t("outOfRange"));
              data.value = 1;
            }
          }
        },
        alarmType: {
          value: 1,
          type: "select",
          width: 120,
          options: this.handleGlobalArr(config.alarmTypeArr)
        },
        quantityOfAlarms: {
          value: 1,
          type: "select",
          width: 120,
          options: this.quantityOfAlarmsArr
        },
        combination: {
          value: 0,
          type: "select",
          width: 120,
          options: this.combinationArr
        }
      });
      // this.canAddaps = false
    },
    delScenarioRow(data, index) {
      this.$msgbox({
        title: this.$t("prompt"),
        message: this.$t("sureDelete"),
        showCancelButton: true,
        confirmButtonText: this.$t("sure"),
        cancelButtonText: this.$t("cancel"),
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            // instance.confirmButtonText = '执行中...'
            if (data.id) {
              delAps({
                id: data.id
              }).then(res => {
                this.$message.success(this.$t("deleteSuccess"));
                this.getApsList();
                done();
              });
            } else {
              this.$message.success(this.$t("deleteSuccess"));
              this.scenarioNew.splice(index - this.scenarioSource.length, 1);
              // this.scenarioSource.splice(index, 1)
              this.canAddaps = true;
              done();
            }
          } else {
            done();
          }
        }
      }).then(action => {});
    },
    saveScenarioRow(data, index) {
      if (data.id) {
        updateAps({
          id: data.id,
          actionNumId: this.activeId,
          // sort: data.line.value,
          zone: data.zone.value,
          alarmType: data.alarmType.value,
          alarmCounts: data.quantityOfAlarms.value,
          combination: data.combination.value
        }).then(res => {
          this.$message.success(this.$t("saveSuccess"));
          this.getApsList();
        });
      } else {
        addAps({
          actionNumId: this.activeId,
          // sort: data.line.value,
          zone: data.zone.value,
          alarmType: data.alarmType.value,
          alarmCounts: data.quantityOfAlarms.value,
          combination: data.combination.value
        }).then(res => {
          this.$message.success(this.$t("addSuccess"));
          this.scenarioNew.splice(index - this.scenarioSource.length, 1);
          this.getApsList();
        });
      }
    },
    addNewApa() {
      if (!this.activeId) {
        return;
      }
      if (!this.canAddapa) {
        this.$message.error(this.$t("unSavedWarning"));
        return;
      }
      if (this.activationSource.length + this.activationNew.length >= 16) {
        this.$message.error(this.$t("activationLimit"));
        return;
      }
      let value = 1;
      let num = 1;
      const activationAll = this.activationSource.concat(this.activationNew);
      if (activationAll.length > 0) {
        activationAll.map(n => {
          if (n.groupToActivate.value > num) {
            num = n.groupToActivate.value;
          }
        });
        num += 1;
      }
      this.activationNew.push({
        isEdit: true,
        line: {
          value: value
        },
        groupToActivate: {
          value: num,
          type: "input",
          width: 120,
          change: data => {
            const value = +data.value;
            if (value < 1 || value > 400 || isNaN(value)) {
              this.$message.error(this.$t("outOfRange"));
              data.value = 1;
            }
          }
        },
        delay: {
          value: 0,
          type: "input",
          width: 120,
          change: data => {
            const value = +data.value;
            if (value < 0 || value > 600 || isNaN(value)) {
              this.$message.error(this.$t("outOfRange"));
              data.value = 0;
            }
          }
        },
        hold: {
          value: 0,
          type: "input",
          width: 120,
          change: data => {
            const value = +data.value;
            if (value < 0 || value > 63 || isNaN(value)) {
              this.$message.error(this.$t("outOfRange"));
              data.value = 0;
            }
          }
        },
        twoStages: {
          value: 0,
          type: "select",
          width: 120,
          options: [
            {
              name: this.$t("enabled"),
              value: 1
            },
            {
              name: this.$t("disabled"),
              value: 0
            }
          ]
        }
      });
      // this.canAddapa = false
    },
    delActivationRow(data, index) {
      this.$msgbox({
        title: this.$t("prompt"),
        message: this.$t("sureDelete"),
        showCancelButton: true,
        confirmButtonText: this.$t("sure"),
        cancelButtonText: this.$t("cancel"),
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            // instance.confirmButtonText = '执行中...'
            if (data.id) {
              delApa({
                id: data.id
              }).then(res => {
                this.$message.success(this.$t("deleteSuccess"));
                this.getApaList();
                done();
              });
            } else {
              this.$message.success(this.$t("deleteSuccess"));
              this.activationNew.splice(
                index - this.activationSource.length,
                1
              );
              // this.activationSource.splice(index, 1)
              this.canAddapa = true;
              done();
            }
          } else {
            done();
          }
        }
      }).then(action => {});
    },
    saveActivationRow(data, index) {
      if (data.id) {
        updateApa({
          id: data.id,
          actionNumId: this.activeId,
          // sort: data.line.value,
          groupNo: data.groupToActivate.value,
          delay: data.delay.value,
          hold: data.hold.value,
          twoStages: data.twoStages.value
        }).then(res => {
          this.$message.success(this.$t("saveSuccess"));
          this.getApaList();
        });
      } else {
        addApa({
          actionNumId: this.activeId,
          // sort: data.line.value,
          groupNo: data.groupToActivate.value,
          delay: data.delay.value,
          hold: data.hold.value,
          twoStages: data.twoStages.value
        }).then(res => {
          this.$message.success(this.$t("addSuccess"));
          this.activationNew.splice(index - this.activationSource.length, 1);
          this.getApaList();
        });
      }
    },
    getApaList() {
      const params = {
        actionNumId: this.activeId
      };
      getApaList(params).then(res => {
        this.canAddapa = true;
        this.activationSource = res.data.map((n, i) => {
          return {
            isEdit: true,
            id: n.id,
            // line: {
            //   value: i + 1
            // },
            groupToActivate: {
              value: n.groupNo,
              type: "input",
              width: 120,
              change: data => {
                const value = +data.value;
                if (value < 1 || value > 400 || isNaN(value)) {
                  this.$message.error(this.$t("outOfRange"));
                  data.value = 1;
                }
              }
            },
            delay: {
              value: n.delay,
              type: "input",
              width: 120,
              change: data => {
                const value = +data.value;
                if (value < 0 || value > 600 || isNaN(value)) {
                  this.$message.error(this.$t("outOfRange"));
                  data.value = 0;
                }
              }
            },
            hold: {
              value: n.hold,
              type: "input",
              width: 120,
              change: data => {
                const value = +data.value;
                if (value < 0 || value > 63 || isNaN(value)) {
                  this.$message.error(this.$t("outOfRange"));
                  data.value = 0;
                }
              }
            },
            twoStages: {
              value: n.twoStages,
              type: "select",
              width: 120,
              options: [
                {
                  name: this.$t("enabled"),
                  value: 1
                },
                {
                  name: this.$t("disabled"),
                  value: 0
                }
              ]
            }
          };
        });
        this.activationSourceCopy = JSON.parse(
          JSON.stringify(this.activationSource)
        );
      });
    },
    formatNo(num) {
      return "S" + "000".substr(0, 3 - ("" + num).length) + num;
    },
    upload(file) {
      const params = new FormData();
      params.append("file", file);
      params.append("userId", Cookies.get(config.userId));
      params.append("panelNo", this.panelNo);
      params.append("projectId", this.projectId);
      params.append("lan", Cookies.get(config.language));
      if (file) {
        importAdvance(params).then(res => {
          this.$message.success(this.$t("importFilesuccess"));
          this.uploadVisible = false;
          this.getApsList();
          this.getApaList();
          this.getActionNumList();
        });
      }
    },
    exportFile() {
      exportAdvance({
        projectId: this.projectId,
        userId: Cookies.get(config.userId),
        panelNo: this.panelNo
      }).then(res => {
        this.$message.success(this.$t("exportFilesuccess"));
      });
    },
    searchActionNum() {
      this.filterKey = this.actionNum;
    },
    saveAllApa() {
      const activationAll = this.activationSource.concat(this.activationNew);
      if (activationAll.length > 0) {
        const arr = activationAll.map(n => {
          return {
            id: n.id || "",
            actionNumId: this.activeId,
            groupNo: n.groupToActivate.value,
            delay: n.delay.value,
            hold: n.hold.value,
            twoStages: n.twoStages.value
          };
        });
        saveAllApa({
          apaList: JSON.stringify(arr)
        }).then(res => {
          this.$message.success(this.$t("saveSuccess"));
          this.activationNew = [];
          this.getApaList();
        });
      }
    },
    saveAllAps() {
      const scenarioAll = this.scenarioSource.concat(this.scenarioNew);
      if (scenarioAll.length > 0) {
        const arr = scenarioAll.map(n => {
          return {
            id: n.id || "",
            actionNumId: this.activeId,
            zone: n.zone.value,
            alarmType: n.alarmType.value,
            alarmCounts: n.quantityOfAlarms.value,
            combination: n.combination.value
          };
        });
        saveAllAps({
          apsList: JSON.stringify(arr)
        }).then(res => {
          this.$message.success(this.$t("saveSuccess"));
          this.scenarioNew = [];
          this.getApsList();
        });
      }
    },
    // 检查数据是否有改动
    checkData() {
      const aps = ["zone", "alarmType", "quantityOfAlarms", "combination"];
      const apa = ["groupToActivate", "delay", "hold", "twoStages"];
      let flag = "";
      this.scenarioSource.map((n, i) => {
        aps.map(m => {
          if (this.scenarioSourceCopy[i][m].value !== n[m].value) {
            flag = "aps";
          }
        });
      });
      this.activationSource.map((n, i) => {
        apa.map(m => {
          if (this.activationSourceCopy[i][m].value !== n[m].value) {
            flag = "apa";
          }
        });
      });
      return flag;
    },
    // 确认对话框
    showMsg(id, index, type = "", cancleCbFn = null) {
      this.$msgbox({
        title: this.$t("prompt"),
        message: this.$t("unsavedRemind"),
        showClose: false,
        closeOnClickModal: false,
        showCancelButton: true,
        confirmButtonText: this.$t("sure"),
        cancelButtonText: this.$t("cancel"),
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (this.scenarioNew.length > 0 || type === "aps") {
              this.saveAllAps();
            }
            if (this.activationNew.length > 0 || type === "apa") {
              this.saveAllApa();
            }
            done();
          } else {
            if (cancleCbFn) {
              cancleCbFn();
            } else {
              this.activeId = id;
              this.activeNum = index;
              this.getApsList();
              this.getApaList();
            }
            done();
          }
        }
      }).then(action => {});
    }
  }
};
</script>

<style lang="less">
.program-main {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  .add-btn {
    color: @color-blue;
    text-align: center;
    margin: 10px 0;
    i {
      font-size: 40px;
      cursor: pointer;
    }
  }
  .action-list {
    .item {
      height: 36px;
      line-height: 36px;
      padding-left: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .action-item-content {
        display: flex;
        align-items: center;
        flex: 1;
        overflow: hidden;
        span {
          margin-right: 8px;
          white-space: nowrap;
        }
        .descr-input {
          flex: 1;
          margin-right: 8px;
          .el-input__inner {
            padding: 0 8px;
            height: 24px;
            line-height: 24px;
          }
        }
      }
      i {
        color: @color-blue;
        margin-right: 10px;
        cursor: pointer;
      }
    }
  }
  .left-section {
    width: 200px;
    height: 100%;
    .top-section {
      display: flex;
      justify-content: space-between;
    }
  }
  .right-section {
    width: calc(100% - 200px);
    padding-left: 20px;
    height: 100%;
    .title {
      font-size: 18px;
    }
    .top-section {
      height: 50%;
    }
    .bottom {
      height: 50%;
    }
    .blue-btn {
      // position: relative;
      margin-bottom: 10px;
    }
  }
  .warning {
    color: red;
  }
  .active {
    color: @color-blue;
  }
}
.top-group {
  text-align: right;
  margin: 10px 0;
  i {
    font-size: 30px;
    margin: 0 10px;
    cursor: pointer;
  }
}
.icon-baocun,
.icon-bianji {
  margin-left: 15px;
}
.diabled-icon {
  color: #a0cfff;
}
h1 {
  font-size: 24px;
  font-weight: 400;
}
</style>
